/* SNODIS Relaunch – small UI helpers */
(function () {
  function initSticky() {
    var bar = document.querySelector("[data-sn-sticky]");
    if (!bar) return;
    var root = bar.closest("section") || document;
    var btn = root.querySelector(".product-form__submit");
    if (!btn) return;
    var priceEl = bar.querySelector("[data-sn-sticky-price]");
    bar.querySelector("button").addEventListener("click", function () {
      if (!btn.disabled) { btn.click(); return; }
      btn.scrollIntoView({ behavior: "smooth", block: "center" });
    });
    var ticking = false;
    function update() {
      ticking = false;
      var r = btn.getBoundingClientRect();
      var show = r.bottom < 0;
      bar.classList.toggle("is-visible", show);
      bar.setAttribute("aria-hidden", show ? "false" : "true");
      var p = root.querySelector(".price__sale .price-item--sale, .price__regular .price-item--regular");
      var box = root.querySelector(".price");
      if (p && box && !box.classList.contains("price--on-sale")) p = root.querySelector(".price__regular .price-item--regular");
      if (p && priceEl) priceEl.textContent = p.textContent.trim();
    }
    window.addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    /* refresh price after a variant change (Dawn re-renders the price block) */
    if (typeof window.subscribe === "function" && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () { setTimeout(update, 60); });
    }
    root.addEventListener("change", function () { setTimeout(update, 400); });
    update();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initSticky);
  else initSticky();
})();

/* Cart drawer cross-sell */
(function () {
  document.addEventListener("change", function (e) {
    var sel = e.target.closest("[data-sn-upsell-variant]");
    if (!sel) return;
    var btn = sel.closest("[data-sn-upsell]").querySelector("[data-sn-upsell-add]");
    btn.disabled = !sel.value;
  });
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-sn-upsell-add]");
    if (!btn) return;
    var box = btn.closest("[data-sn-upsell]");
    var id = box.querySelector("[data-sn-upsell-variant]").value;
    if (!id) return;
    btn.disabled = true;
    btn.textContent = "Wird hinzugefügt …";
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : "/cart/add") + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: Number(id), quantity: 1, sections: "cart-drawer,cart-icon-bubble", sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var drawer = document.querySelector("cart-drawer");
        if (json.status || !drawer || !json.sections) { window.location.href = "/cart"; return; }
        drawer.renderContents(json);
      })
      .catch(function () { window.location.href = "/cart"; });
  });
})();
